import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { IBatchItemReturn } from "../../../model/ItemModel";
import { BatchInnerHandler } from "./BatchInnerHandler";
import { BatchTabPanel } from "./BatchTabPanel";

interface IBatchActionInnerBody {
    files: IBatchItemReturn[];
    value: number;
    index: number;
    type: "REPROVED" | "APPROVED"
}

export const BatchActionInnerBody : React.FC<IBatchActionInnerBody> = ({
    files,
    value,
    index,
    type
}) => {

    const { t } = useTranslation();

    return (
        <BatchTabPanel value={value} index={index}>
            <Box
                width="540px"
                height="300px"
                border="1px solid #2D2D2D1A"
                borderRadius="4px"
                display="flex"
                flexDirection="column"
                maxWidth="540px"
                sx={{
                    overflowY: "auto",
                }}
            >
                <Box
                    borderBottom="1px solid #2D2D2D1A"
                >
                    <Typography
                        fontFamily="segoe ui"
                        fontSize="14px"
                        fontWeight={600}
                        padding={1.5}
                        marginLeft={3.5}
                    >
                        {t("BatchActionModal.documentName")}
                    </Typography>
                </Box>
                <BatchInnerHandler
                    files={files}
                    type={type}
                />
            </Box>
        </BatchTabPanel>
    )
}